import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useContext, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { borderRadius, tabHeight, } from './constants';
import { TabToggleButtonContext } from './TabToggleButtonContext';
import { TabToggleSwitchContext } from './TabToggleSwitchContext';
const defaultProps = {
    onClick: () => { },
    text: '',
};
const TabToggleButton = ({ onClick = defaultProps.onClick, text = defaultProps.text, }) => {
    const { currentTabNumber, } = useContext(TabToggleSwitchContext);
    const { panelId, tabId, tabNumber, } = useContext(TabToggleButtonContext);
    const isSelected = useMemo(() => (currentTabNumber === tabNumber), [
        currentTabNumber,
        tabNumber,
    ]);
    const buttonStyles = useMemo(() => (css `
        ${styleUtils.buttonReset}
        ${styleUtils.borderBox}
        ${theme.typeStyles.bodyExtraSmallStyles}
        ${theme.typeStyles.bodyBoldStyles}
        align-items: center;
        background-color: transparent;
        border-radius: ${styleUtils.rem(borderRadius)};
        cursor: pointer;
        height: ${styleUtils.rem(tabHeight)};
        justify-content: center;
        overflow: hidden;
        padding-bottom: ${theme.spacing.base};
        padding-left: ${theme.spacing.x2};
        padding-right: ${theme.spacing.x2};
        padding-top: ${theme.spacing.base};
        position: inherit;
        text-align: center;
        text-decoration: none;
        transition: color 250ms ease-in-out;
        white-space: nowrap;
        width: 100%;

        &:hover {
          background-color: ${theme.colors.gray300};
        }

        ${isSelected && css `
          color: ${theme.colors.gray100};

          &:hover {
            background-color: transparent;
          }
        `}
      `), [
        isSelected,
    ]);
    const buttonTextStyles = useMemo(() => (css `
        ${theme.typeStyles.bodyExtraSmallStyles}
        ${theme.typeStyles.bodyBoldStyles}
        overflow: hidden;
        text-align: center;
        text-overflow: ellipsis;

        ${isSelected && css `
          color: ${theme.colors.gray100};
        `}
      `), [
        isSelected,
    ]);
    return (_jsx("button", Object.assign({ "aria-controls": panelId, "aria-selected": isSelected, css: buttonStyles, id: tabId, onClick: onClick, role: "tab", type: "button" }, { children: _jsx("span", Object.assign({ css: buttonTextStyles }, { children: text })) })));
};
const MemoizedTabToggleButton = memo(TabToggleButton);
export { MemoizedTabToggleButton as TabToggleButton };
